import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=329a5f6c&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=329a5f6c&prod&lang=scss&scoped=true&"
import style1 from "./Settings.vue?vue&type=style&index=1&id=329a5f6c&prod&scoped=true&lang=css&"
import style2 from "./Settings.vue?vue&type=style&index=2&id=329a5f6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329a5f6c",
  null
  
)

export default component.exports